<template>
  <div class="main-layout">
    <app-header />
    <div class="main-body">
      <app-sidebar />
      <main class="main-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppSidebar from '@/components/layout/AppSidebar.vue'
import { getModuleByPath } from '@/config/menus'

export default {
  name: 'MainLayout',
  components: {
    AppHeader,
    AppSidebar
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(path) {
        this.$store.commit('app/SET_CURRENT_MODULE', getModuleByPath(path))
      }
    }
  }
}
</script>
